import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "sectors", label: "Sectors" },
  { id: "approach", label: "Approach" },
  { id: "why", label: "Why TAQAVED" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => handleClick("hero")}
          data-testid="nav-logo-btn"
          className="focus:outline-none"
          aria-label="Go to top"
        >
          <Logo variant={scrolled ? "dark" : "light"} />
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => handleClick(l.id)}
              data-testid={`nav-link-${l.id}`}
              className={`text-sm font-medium link-underline ${
                scrolled ? "text-slate-700 hover:text-slate-900" : "text-white/90 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => handleClick("contact")}
            data-testid="nav-cta-contact"
            className="btn-primary px-5 py-2.5 rounded-full text-sm font-semibold"
          >
            Get in touch
          </button>
        </div>

        <button
          className="lg:hidden p-2 rounded-md"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? (
            <X className={scrolled ? "text-slate-900" : "text-white"} />
          ) : (
            <Menu className={scrolled ? "text-slate-900" : "text-white"} />
          )}
        </button>
      </nav>

      {open && (
        <div
          className="lg:hidden bg-white border-t border-slate-200 shadow-lg"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => handleClick(l.id)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="text-left py-2 text-slate-800 font-medium"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => handleClick("contact")}
              data-testid="nav-mobile-cta-contact"
              className="btn-primary mt-2 px-5 py-3 rounded-full text-sm font-semibold text-center"
            >
              Get in touch
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
